import { faCircle as faCirlceReg } from "@fortawesome/free-regular-svg-icons"
import { faChevronLeft, faChevronRight, faCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useClient } from "Client/ClientAndUserProvider"
import { ImageRenderMode, ImageType, ProductImage } from "Client/ProductDefinitionsByCategories"
import { exhaustive } from "exhaustive"
import { ProductImage as ProductImageRenderer } from "Orders/Components/ProductImage/ProductImage"
import { FC, useRef, useState } from "react"
import { EasingMethodType } from "../../Shared/ImageSlider/helpers"
import { ImageSlider } from "../../Shared/ImageSlider/ImageSlider"
import { SlideshowRef } from "../../Shared/ImageSlider/types"
import style from "./ProductImageSlideshow.module.css"

type ProductImageSlideshowProps = {
	images: ProductImage[]
	categoryName: string
}

export const ProductImageSlideShow: FC<ProductImageSlideshowProps> = ({ images, categoryName }) => {
	const [slideIndex, setSlideIndex] = useState(1)
	const client = useClient()

	const slideShowRef = useRef<SlideshowRef | null>(null)

	return (
		<div style={{ backgroundColor: "var(--product-image-background-color)" }}>
			<ImageSlider
				ref={slideShowRef}
				defaultIndex={slideIndex}
				transitionDuration={300}
				canSwipe={true}
				arrows={true}
				autoplay={false}
				infinite={true}
				easing={EasingMethodType.Ease}
				swipeThreshold={15}
				onChange={(_, to) => {
					setSlideIndex(to)
				}}
				prevArrow={
					<span className={style.prev}>
						<FontAwesomeIcon icon={faChevronLeft} className={style.slideshowArrow} />
					</span>
				}
				nextArrow={
					<span className={style.next}>
						<FontAwesomeIcon icon={faChevronRight} className={style.slideshowArrow} />
					</span>
				}>
				{images.map((slideImage, index) => (
					<div style={{ hyphens: "auto" }} key={index}>
						{exhaustive(slideImage, "type", {
							[ImageType.Typed]: (it) => (
								<ProductImageRenderer
									client={client}
									categoryName={categoryName}
									image={it.typeImage}
									wrapperClassName={style.productImageWrapper}
								/>
							),
							[ImageType.Url]: (it) => (
								<div
									className={
										it.renderMode === ImageRenderMode.Fill
											? style.imageWrapperFill
											: style.imageWrapperFit
									}>
									<img
										onDragStart={(e) => {
											e.preventDefault()
										}}
										className={
											it.renderMode === ImageRenderMode.Fill ? style.imageFill : style.imageFit
										}
										src={it.url}
										alt="Bild"
									/>
								</div>
							),
						})}
					</div>
				))}
			</ImageSlider>
			<div style={{ display: "flex", justifyContent: "center", marginTop: "0.5rem", gap: "0.5rem" }}>
				{images.map((_, index) => (
					<span
						onClick={() => {
							const ref = slideShowRef.current
							if (ref) {
								ref.goTo(index)
							}
						}}
						key={`slider_footer_${index}`}>
						<FontAwesomeIcon
							icon={index === slideIndex ? faCircle : faCirlceReg}
							className={index === slideIndex ? style.selectedDot : style.regularDot}
						/>
					</span>
				))}
			</div>
		</div>
	)
}
